module.exports = __webpack_public_path__ + "a36415ba427eaa2248998bcb7c6bafc4.svg";